import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube } from 'lucide-react';
import { CONTACT, LOGO_WHITE } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-[#0F1C2E] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="mb-4"><img src={LOGO_WHITE} alt="Wrappus" className="h-24 w-auto" /></div>
          <p className="text-white/70 leading-relaxed text-sm max-w-xs">Port Coquitlam’s go-to spot for juicy donairs, loaded poutines, rice plates, and late-night eats.</p>
        </div>
        <div>
          <h6 className="text-white font-bold uppercase tracking-wider text-sm mb-4">Important Links</h6>
          <ul className="space-y-3">
            <li><Link to="/franchising" className="text-white/70 hover:text-[#ED2E2E] transition-colors">Franchising</Link></li>
            <li><Link to="/my-orders" className="text-white/70 hover:text-[#ED2E2E] transition-colors">My Orders</Link></li>
            <li><Link to="/faqs" className="text-white/70 hover:text-[#ED2E2E] transition-colors">FAQs</Link></li>
            <li><Link to="/about" className="text-white/70 hover:text-[#ED2E2E] transition-colors">About</Link></li>
            <li><Link to="/contact" className="text-white/70 hover:text-[#ED2E2E] transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h6 className="text-white font-bold uppercase tracking-wider text-sm mb-4">Follow Us</h6>
          <div className="flex gap-3">
            <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#ED2E2E] transition-colors flex items-center justify-center">
              <Instagram size={18} />
            </a>
            <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#ED2E2E] transition-colors flex items-center justify-center">
              <Facebook size={18} />
            </a>
            <a href={CONTACT.youtube} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#ED2E2E] transition-colors flex items-center justify-center">
              <Youtube size={18} />
            </a>
          </div>
          <div className="mt-6 text-white/70 text-sm space-y-2">
            <div><span className="text-white font-semibold">Phone:</span> {CONTACT.phone}</div>
            <div><span className="text-white font-semibold">Email:</span> {CONTACT.email}</div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 text-center text-white/60 text-xs">
          Proudly owned & operated in Port Coquitlam, Canada. | © {new Date().getFullYear()} Wrappus Donair Inc. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
